// actions.js
export const setOrderData = (orderData) => ({
    type: 'SET_ORDER_DATA',
    payload: orderData,
  });
  
  export const setOrderSuccess = () => ({
    type: 'SET_ORDER_SUCCESS',
  });
  